import ImageCarousel from 'LuxKit/Carousel/ImageCarousel'
import styled from 'styled-components'
import { rem } from 'polished'

const BaseContainer = styled.div`
  position: absolute;
  width: ${rem(56)};
  height: ${rem(56)};
  border-radius: ${props => props.theme.borderRadius.M};
  overflow: hidden;

  @container (min-width: 640px) {
    width: 100%;
    height: 100%;

    /* calc - 1px to avoid gap with the container border*/
    &:not(.showComment) {
      border-radius: calc(${props => props.theme.borderRadius.L} - 1px) 0 0 calc(${props => props.theme.borderRadius.L} - 1px);
    }

    &.showComment {
      border-radius: calc(${props => props.theme.borderRadius.L} - 1px) 0 0 0;
    }
  }
`

interface Props {
  images: Array<App.Image>
  className?: string
}

function ItemCardImageCarousel({ images, className }: Props) {
  return (
    <BaseContainer className={className}>
      <ImageCarousel images={images} arrowStyle="ghost" bottomLeft={<div></div>} />
    </BaseContainer>
  )
}

export default ItemCardImageCarousel
